import createClient from 'openapi-fetch'
import type { paths } from '../types/integrations/commerce/operations'
import type {
  CommerceArchiveContractBody,
  ContractType,
  UpdateContractStatusRequest,
  UploadDocumentRequest,
} from '../types/integrations/commerce/common'
import { getMiddleware } from './utils'

const commerceClient = createClient<paths>({
  baseUrl: 'http://integration-proxy-api/commerce',
})
commerceClient.use(getMiddleware())

export async function updateContractStatus(body: UpdateContractStatusRequest) {
  const { data } = await commerceClient.POST('/api/StaccContractApi/UpdateContractStatus', { body })
  return data
}

export async function uploadDocument(body: UploadDocumentRequest) {
  const { data } = await commerceClient.POST('/api/StaccContractApi/UploadDocument', { body })
  return data
}

export async function getContractDocument(contractId: number, contractType: ContractType, documentId: number) {
  const { data } = await commerceClient.GET('/api/StaccContractApi/GetContractDocument', {
    params: { query: { contractId, contractType, documentId } },
  })
  return data
}

export async function getAttachedFile(contractId: number, contractType: ContractType, fileId: number) {
  const { data } = await commerceClient.GET('/api/StaccContractApi/GetAttachedFile', {
    params: { query: { contractId, contractType, fileId } },
  })
  return data
}

export async function archiveContract(body: CommerceArchiveContractBody) {
  return await commerceClient.POST('/api/StaccContractApi/ToggleContractArchive', {
    body,
  })
}
